import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Routes } from '@/_shared/constants/routes';
import { getSurveysCampaignsCall, getTemplatesCall } from '../api';

export const useSurvey = () => {
  const navigate = useNavigate();
  const {
    response: responseGetTemplates,
    hardSkillTemplate,
    softSkillTemplate,
  } = getTemplatesCall.hook();
  const {
    response: responseGetSurveysCampaigns,
    success: successGetSurveysCampaigns,
    execute: executeGetSurveysCampaigns,
  } = getSurveysCampaignsCall.hook();

  /**
   * Get the list of template IDs that have active survey campaigns
   */
  const activeCampaignsTemplateIds = useMemo(() => {
    if (!responseGetSurveysCampaigns) return [];

    return responseGetSurveysCampaigns.map(campaign => campaign.surveyTemplateId);
  }, [responseGetSurveysCampaigns]);

  /**
   * Get the template name if there is only one active campaign, useful for setActiveChip
   */
  const getOnlyTemplateNameActiveCampaigns = useMemo(() => {
    if (!responseGetSurveysCampaigns) return [];

    const activeTemplate = responseGetSurveysCampaigns.map(campaign => campaign.surveyTemplateId);

    if (activeTemplate.length === 1) {
      return responseGetTemplates?.find(t => t.id === activeTemplate[0]);
    }

    return '';
  }, [responseGetSurveysCampaigns, responseGetTemplates]);

  /**
   * Check if the organization has an active campaign for hard skill template
   */
  const organizationHasCampaignsHardSkill = useMemo(() => {
    return activeCampaignsTemplateIds.includes(hardSkillTemplate?.id);
  }, [activeCampaignsTemplateIds, hardSkillTemplate]);

  /**
   * Check if the organization has an active campaign for soft skill template
   */
  const organizationHasCampaignsSoftSkill = useMemo(() => {
    return activeCampaignsTemplateIds.includes(softSkillTemplate?.id);
  }, [activeCampaignsTemplateIds, softSkillTemplate]);

  /**
   * Navigate to the survey detail page for hard skill template
   */
  const goToSurveyHardSkill = () => {
    navigate(Routes.SurveyDetail.replace(':surveyId', hardSkillTemplate?.id || ''));
  };

  /**
   * Navigate to the survey detail page for soft skill template
   */
  const goToSurveySoftSkill = () => {
    navigate(Routes.SurveyDetail.replace(':surveyId', softSkillTemplate?.id || ''));
  };

  useEffect(() => {
    if (!successGetSurveysCampaigns) {
      executeGetSurveysCampaigns({});
    }
  }, [executeGetSurveysCampaigns, successGetSurveysCampaigns]);

  return {
    activeCampaignsTemplateIds,
    getOnlyTemplateNameActiveCampaigns,
    goToSurveyHardSkill,
    goToSurveySoftSkill,
    organizationHasCampaignsHardSkill,
    organizationHasCampaignsSoftSkill,
    softSkillTemplate,
    softSkillGetTemplateId: softSkillTemplate?.id || '',
    softSkillGetListMetrics: softSkillTemplate?.metrics || [],
    hardSkillTemplate,
  };
};
